<template>
    <button
        class="flex items-center gap-8 py-8 px-16 border rounded-4 w-fit"
        :class="[disabled ? 'cursor-not-allowed bg-primary-5 border-primary-20 text-primary-40' : 'cursor-pointer bg-white border-primary-40 hover:bg-primary-20 text-black' ]"
        @click="$emit('click')"
    >
        <slot name="before">
            <svg-icon
                v-if="!noIcon && iconBefore"
                class="w-18 h-18"
                :class="[iconColor ? 'fill-' + iconColor : '']"
                :type="icon"
            />
        </slot>
        <slot></slot>
        <slot name="after">
            <svg-icon
                v-if="!noIcon && !iconBefore"
                class="w-18 h-18"
                :class="[iconColor ? 'fill-' + iconColor : '']"
                :type="icon"
            />
        </slot>
    </button>
</template>
<script>
import SvgIcon from './SvgIcon.vue';
export default {
    name: "ActionButton",
    components: {
        SvgIcon,
    },
    props: {
        icon: {
            type: String,
            default: 'add'
        },
        iconColor: String,
        noIcon: Boolean,
        disabled: Boolean,
        iconBefore: Boolean,
    }
}
</script>
<style scoped>

</style>